import { ButtonGroupProps } from "@mui/material";
import React from "react";
export const WcButtonGroup = ( {...props }: ButtonGroupProps) => (
    <WcButtonGroup  {...props} />
  );
  